/*import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from './services/auth.service';
import { RoutesEnum } from './enums/routes-enum';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router, private activatedRoute: ActivatedRoute) {}

canActivate(): Observable<boolean> {
    return this.authService.isAuthenticated().pipe(
      map(isAuth => {
        if (!isAuth) {
          this.router.navigate(['/signin']);
          return false;
        }
        const mustChangePassword = this.authService.getMustChangePassword();
        //const currentRoute = this.activatedRoute.snapshot.url.map(u => u.path).join('/');

        const currentRoute = this.router.url; // '/first-login-change-password' ou '/company/titre-restaurant'
if (mustChangePassword && currentRoute !== '/first-login-change-password') {
  this.router.navigate(['/first-login-change-password']);
  return false;
}


        return true;
      })
    );

  }

}*/

import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from './services/auth.service';
import { RoutesEnum } from './enums/routes-enum';


@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): Observable<boolean> {
    return this.authService.isAuthenticated().pipe(
      map(isAuth => {
        const currentRoute = this.router.url; 
        const mustChangePassword = this.authService.getMustChangePassword();
       // console.log('AuthGuard - isAuth:', isAuth);
        if (!isAuth) {
          this.router.navigate(['/signin']);
          return false;
        }

        // L'utilisateur doit changer son mot de passe
        // if (mustChangePassword && currentRoute !== '/first-login-change-password') {
        //   this.router.navigate(['/first-login-change-password']);
        //   return false;
        // }

        
        return true;
      })
    );
  }
}

